var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './FileUploader.module.scss';
import { UserGray } from '../../assets/icons';
import { Button } from '../Button/Button';
var FileUploader = function (_a) {
    var image = _a.image, placeholder = _a.placeholder, disabled = _a.disabled, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange;
    var _b = useState(null), selected = _b[0], setSelected = _b[1];
    var inputRef = useRef();
    var firstRender = useRef(true);
    useEffect(function () {
        firstRender.current ? (firstRender.current = false) : onChange(selected);
    }, [selected]);
    var onChooseClick = function () {
        inputRef.current.click();
    };
    var onValueChange = function (e) {
        var _a;
        var file = ((_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length) && e.target.files[0];
        file && setSelected(file);
    };
    var onFileRemove = function () {
        inputRef.current.value = '';
        selected ? setSelected(null) : onChange(null);
    };
    return (_jsxs("section", __assign({ id: id, className: "".concat(styles.FileUploader, " ").concat(className ? className : ''), "data-testid": dataId }, { children: [_jsx("input", { type: 'file', ref: inputRef, className: styles.FileInput, onChange: onValueChange, "data-testid": 'file-input' }), _jsxs("section", __assign({ className: styles.FileSelector }, { children: [image && _jsx("img", { className: styles.SelectedFile, src: image, alt: '' }), !image && _jsx(UserGray, {}), _jsxs("section", __assign({ className: styles.FileActions }, { children: [_jsxs("section", { children: [!image && (_jsx(Button, { title: 'Choose file', className: styles.ActionButton, small: true, disabled: disabled, onClick: onChooseClick })), image && (_jsxs(_Fragment, { children: [_jsx(Button, { title: 'Change', className: styles.ActionButton, small: true, disabled: disabled, onClick: onChooseClick }), _jsx(Button, { title: 'Remove', className: styles.ActionButton, small: true, disabled: disabled, onClick: onFileRemove, dataId: 'file-remove' })] }))] }), _jsx("section", __assign({ className: styles.Data }, { children: placeholder && _jsx("span", { children: placeholder }) }))] }))] }))] })));
};
FileUploader.propTypes = {
    image: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
export { FileUploader };
//# sourceMappingURL=FileUploader.js.map